var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 978.68 954.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{opacity:.5;}.g,.h{fill:#000069;}.g,.h,.i,.j,.k,.l,.m{stroke-width:0px;}.i{fill:url(#b);}.j{fill:url(#c);}.k{fill:url(#e);}.l{fill:url(#f);}.m{fill:url(#d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 449.66,
    y1: 536.06,
    x2: 560.83,
    y2: 536.06,
    gradientTransform: "translate(-9.78 12.79) rotate(-1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000069",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 478.7,
    y1: 306.45,
    x2: 590.72,
    y2: 306.45,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 185.28,
    y1: 259.18,
    x2: 302.21,
    y2: 259.18,
    gradientTransform: "translate(-9.78 12.79) rotate(-1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000069",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 506.9,
    y1: 107.59,
    x2: 613.69,
    y2: 107.59,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 210.33,
    y1: 80.68,
    x2: 322.92,
    y2: 80.68,
    xlinkHref: "#d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M634.42,729.67c.33.02.67.12,1.03.31l88.09,46.98c1.46.78,2.51,2.76,2.33,4.4l-8.52,77.63c-.14,1.29-1.03,2.05-2.13,1.98-.3-.02-.61-.1-.93-.24l-88.64-40.56c-1.51-.69-2.58-2.6-2.41-4.25l9.23-84.38c.14-1.24.95-1.95,1.95-1.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M821.57,827.27c.3.02.6.1.92.24l88.71,40.01c1.51.68,2.58,2.58,2.41,4.22l-8.93,81.28c-.15,1.29-1.01,2.04-2.1,1.97-.31-.02-.62-.1-.95-.25l-88.53-41.72c-1.49-.71-2.57-2.63-2.39-4.27l8.71-79.48c.15-1.3,1.04-2.07,2.15-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M550.4,597.95c.26.02.54.08.82.18l89.15,34.78c1.53.6,2.65,2.44,2.46,4.08l-9.7,88.57c-.15,1.39-1.19,2.25-2.45,2.17-.23-.02-.48-.06-.72-.15l-89.52-30.7c-1.57-.54-2.7-2.32-2.52-3.97l10.19-92.88c.14-1.35,1.12-2.16,2.3-2.08Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M737.54,689.77c.34.02.7.13,1.07.35l87.78,50.48c1.43.83,2.46,2.85,2.28,4.48l-8.59,78.21c-.13,1.25-.96,1.98-1.99,1.91-.32-.02-.66-.12-1-.29l-88.21-45.16c-1.47-.75-2.53-2.71-2.35-4.36l9.17-83.78c.13-1.22.89-1.91,1.85-1.84Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M465.18,482.17h.03s92,7.22,92,7.22c1.65.13,2.85,1.59,2.67,3.22l-11.14,101.44c-.17,1.65-1.68,2.92-3.33,2.83l-92.24-4.93h-.04c-1.63-.11-2.81-1.51-2.63-3.15l11.39-103.89c.18-1.62,1.65-2.86,3.29-2.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M734.51,687.46c-.34-.02-.71-.14-1.08-.36l-87.67-51.58c-1.42-.84-2.44-2.87-2.26-4.5l10.8-98.39c.13-1.18.83-1.84,1.72-1.78.36.02.74.17,1.13.41l87.27,56.22c1.39.9,2.38,2.97,2.2,4.62l-10.27,93.53c-.14,1.21-.89,1.89-1.84,1.82Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M829.31,739.11l9.73-88.67c.15-1.32,1.08-2.11,2.24-2.03.28.02.57.08.86.2l88.99,37.11c1.52.64,2.62,2.51,2.44,4.15l-9.64,88c-.14,1.33-1.08,2.13-2.25,2.05-.27-.02-.56-.09-.86-.2l-89.04-36.49c-1.53-.62-2.64-2.48-2.46-4.12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M377.16,382.8l94.96-17.5c.25-.05.47-.07.69-.05,1.26.08,2.09,1.09,1.93,2.48l-12.19,111.22c-.18,1.65-1.65,3.28-3.27,3.64l-95.5,21.54c-.27.06-.54.08-.78.07-1.2-.08-1.97-1.03-1.82-2.39l12.68-115.47c.18-1.65,1.66-3.23,3.29-3.54Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M560.53,486.64l11.99-109.39c.15-1.31,1.05-2.08,2.18-2,.29.02.59.09.9.23l88.79,38.76c1.52.66,2.61,2.55,2.44,4.2l-11.89,108.2c-.14,1.32-1.07,2.11-2.21,2.03-.29-.02-.58-.09-.88-.22l-88.89-37.66c-1.52-.64-2.62-2.51-2.44-4.15Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M837.95,646.25c-.35-.02-.73-.15-1.12-.4l-87.35-55.12c-1.4-.88-2.4-2.95-2.21-4.6l11.85-108.12c.13-1.17.81-1.81,1.69-1.75.36.02.74.15,1.14.42l87.1,58.04c1.37.92,2.35,3.01,2.17,4.66l-11.52,105.09c-.14,1.18-.84,1.84-1.75,1.78Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M287.61,296.52l97.27-35.43c.37-.14.71-.19,1.02-.17.99.06,1.61.87,1.48,2.13l-12.85,117.32c-.18,1.65-1.6,3.43-3.17,3.98l-97.16,34.29c-.36.13-.7.18-1.01.16-1-.07-1.63-.88-1.5-2.15l12.75-116.1c.18-1.65,1.61-3.45,3.16-4.02Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M475.4,361.75l12.55-114.25c.18-1.59,1.58-2.76,3.17-2.65h.15s91.6,10.62,91.6,10.62c1.63.19,2.83,1.68,2.65,3.33l-12.32,112.49c-.18,1.6-1.62,2.81-3.22,2.7h-.09s-91.8-8.95-91.8-8.95c-1.65-.17-2.85-1.64-2.66-3.29Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M667.49,412.46l12.43-113.61c.13-1.17.82-1.83,1.72-1.77.36.02.74.15,1.13.41l87.28,56.26c1.4.89,2.38,2.97,2.2,4.61l-12.46,113.67c-.13,1.18-.82,1.83-1.72,1.77-.35-.02-.73-.15-1.13-.4l-87.25-56.32c-1.39-.9-2.38-2.97-2.2-4.62Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M851.88,533.41l12.06-110c.14-1.21.89-1.89,1.84-1.82.34.02.7.13,1.08.36l87.68,51.61c1.42.85,2.45,2.88,2.27,4.51l-11.23,102.07c-.14,1.27-.97,2-2.03,1.93-.32-.02-.65-.12-.99-.28l-88.31-44.05c-1.48-.74-2.54-2.68-2.36-4.33Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M195.38,235.63l98-40.68c.39-.17.76-.24,1.09-.22.92.06,1.49.83,1.35,2.05l-10.71,97.77c-.18,1.64-1.57,3.51-3.1,4.15l-98.06,41.27c-.4.16-.77.24-1.1.22-.92-.06-1.49-.82-1.35-2.03l10.77-98.41c.18-1.64,1.58-3.5,3.11-4.13Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M390.05,259.63c-1.3-.08-2.18-1.13-2.02-2.55l10.48-95.34c.18-1.65,1.67-3.18,3.3-3.42l94.45-13.43c.2-.03.4-.04.59-.03,1.32.09,2.22,1.15,2.05,2.6l-10.31,94.09c-.18,1.63-1.66,3.18-3.29,3.44l-94.63,14.61c-.22.04-.42.05-.62.03Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M678.35,294.92c-.29-.02-.58-.09-.88-.22l-88.87-37.71c-1.52-.64-2.62-2.52-2.44-4.16l10.4-94.68c.15-1.34,1.11-2.15,2.29-2.07.26.02.55.08.83.19l89.12,35.28c1.53.61,2.64,2.45,2.46,4.09l-10.69,97.24c-.14,1.32-1.07,2.11-2.21,2.03Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M772.9,352.4l10.9-99.59c.13-1.15.77-1.77,1.61-1.71.36.02.76.17,1.17.46l86.82,61.53c1.35.96,2.3,3.08,2.12,4.73l-10.93,99.62c-.13,1.15-.77,1.77-1.61,1.71-.36-.02-.76-.18-1.17-.46l-86.79-61.57c-1.35-.95-2.31-3.08-2.13-4.72Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M103.1,176.97l96.67-30.8c.35-.12.67-.16.95-.14,1.06.07,1.72.92,1.59,2.21l-9.39,85.56c-.18,1.65-1.6,3.44-3.16,4l-97.19,34.9c-.37.14-.71.19-1.02.17-.99-.06-1.62-.88-1.49-2.14l9.84-89.86c.17-1.65,1.6-3.4,3.19-3.89Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M396,159.71l-97.02,33.12c-.35.13-.69.17-.99.15-1.03-.07-1.66-.89-1.53-2.17l8.86-80.74c.18-1.63,1.62-3.36,3.21-3.82l96.29-27.87c.31-.1.62-.13.9-.11,1.1.07,1.8.96,1.66,2.26l-8.23,75.21c-.18,1.65-1.6,3.42-3.17,3.96Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M594.04,154.84h-.13s-91.67-10.06-91.67-10.06c-1.65-.18-2.84-1.67-2.66-3.32l8.02-73.4c.18-1.59,1.58-2.76,3.16-2.65h.16s91.63,10.65,91.63,10.65c1.64.2,2.84,1.69,2.66,3.34l-7.98,72.77c-.17,1.6-1.59,2.78-3.18,2.67Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M782.68,248.63c-.35-.02-.72-.14-1.11-.38l-87.43-54.01c-1.4-.87-2.4-2.93-2.22-4.56l8.45-77c.13-1.22.91-1.92,1.91-1.85.33.02.68.12,1.05.32l87.92,48.71c1.45.8,2.48,2.8,2.3,4.44l-9.1,82.54c-.13,1.19-.85,1.86-1.77,1.8Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M966.99,370.77c-.35-.02-.72-.14-1.11-.38l-87.47-53.98c-1.4-.87-2.41-2.92-2.22-4.56l9.65-88.01c.13-1.24.93-1.96,1.96-1.89.32.02.66.12,1.02.31l87.5,46.28c1.46.78,2.51,2.76,2.35,4.4l-9.9,96.04c-.13,1.19-.84,1.86-1.76,1.8Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M10.03,99.37c.17-1.64,1.67-3.11,3.32-3.27l93.88-8.91c.16-.02.32-.02.47-.01,1.4.09,2.36,1.23,2.19,2.71l-9.32,85c-.18,1.65-1.66,3.2-3.3,3.45L2.66,192.97c-.22.04-.42.05-.62.03-1.3-.08-2.18-1.13-2.02-2.55l10.02-91.08Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M302.84,108.13l-97.38,36.07c-.37.15-.72.2-1.03.18-.98-.06-1.59-.87-1.46-2.11l8.56-77.64c.18-1.64,1.62-3.36,3.21-3.82l96.27-27.92c.32-.09.62-.12.91-.1,1.09.07,1.8.95,1.65,2.25l-7.58,69.07c-.18,1.63-1.6,3.45-3.15,4.02Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M504.94,65.45l-94.24,11.73c-.18.02-.36.03-.54.02-1.35-.09-2.27-1.18-2.1-2.63l6.97-63.61c.18-1.64,1.68-3.1,3.32-3.24L512.1,0c.14-.01.29-.01.42,0,1.42.09,2.41,1.24,2.24,2.74l-6.51,59.35c-.18,1.63-1.67,3.15-3.31,3.35Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M698.61,108.85c-.24-.02-.48-.06-.74-.15l-89.49-31.29c-1.57-.55-2.7-2.33-2.51-3.98l6.53-59.33c.16-1.41,1.25-2.32,2.56-2.23.21.01.43.06.65.12l89.84,27.24c1.58.47,2.73,2.22,2.55,3.86l-6.96,63.62c-.15,1.37-1.18,2.23-2.42,2.15Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M884.76,219.62c-.35-.02-.73-.15-1.13-.41l-87.22-56.27c-1.4-.89-2.39-2.97-2.21-4.62l7.69-70.3c.14-1.27.97-1.99,2.02-1.92.32.02.65.12.99.29l88.28,44.63c1.48.75,2.53,2.7,2.36,4.35l-9.07,82.5c-.13,1.18-.82,1.83-1.72,1.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniFlag);
export default __webpack_public_path__ + "static/media/uni_flag.2dd96d1f3e727930dfef391f61158af8.svg";
export { ForwardRef as ReactComponent };